import { Navigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../context/useAuth";

const RoleRoute = ({ children, allowedRoles = [] }) => {
  const { token, user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-900 text-white p-6">
        <div className="w-12 h-12 rounded-2xl bg-teal-500/20 border border-teal-500/30 flex items-center justify-center mb-4 animate-pulse">
          <i className="ri-shield-user-line text-2xl text-teal-400" />
        </div>
        <p className="text-slate-300 font-medium text-sm">Verifying access permissions...</p>
      </div>
    );
  }

  if (!token) {
    return (
      <Navigate 
        to="/login" 
        state={{ 
          from: location.pathname,
          message: "Please sign in with an Administrator or Instructor account to access the management area." 
        }} 
        replace 
      />
    );
  }

  const userRole = (user?.role || '').toLowerCase();
  const isAllowed = 
    allowedRoles.length === 0 || 
    userRole === 'superadmin' ||
    allowedRoles.some(r => r.toLowerCase() === userRole);

  if (!isAllowed) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900 px-6 py-12">
        <div className="max-w-md w-full bg-slate-950 border border-slate-800 rounded-3xl p-8 text-center shadow-2xl">
          <div className="w-16 h-16 rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center mx-auto mb-5 text-amber-400 text-3xl">
            <i className="ri-lock-2-line" />
          </div>

          <h2 className="text-2xl font-bold text-white mb-2">Access Restricted</h2>
          <p className="text-slate-400 text-sm mb-6 leading-relaxed">
            Your account ({user?.email}) is registered as a <strong className="text-teal-400 capitalize">{userRole || 'Student'}</strong>. Management portal access requires <strong className="text-white">Admin</strong> or <strong className="text-white">Instructor</strong> privileges.
          </p>

          <div className="space-y-3">
            <Link
              to="/dashboard"
              className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-xl bg-teal-600 hover:bg-teal-500 text-white font-bold text-sm transition-all shadow-md cursor-pointer"
            >
              <i className="ri-dashboard-line" /> Go to Student Dashboard
            </Link>

            <button
              type="button"
              onClick={() => {
                logout();
                window.location.href = '/login';
              }}
              className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-xl bg-slate-800 hover:bg-slate-700 text-slate-300 font-semibold text-sm transition-all cursor-pointer border border-slate-700"
            >
              <i className="ri-login-box-line" /> Sign in with Different Account
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default RoleRoute;

